/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `kg/m3` - Kilogram per cubic meter
 * * `g/cm3` - Gram per cubic centimeter
 */
export type DensityUnitEnum = typeof DensityUnitEnum[keyof typeof DensityUnitEnum];


export const DensityUnitEnum = {
  'kg/m3': 'kg/m3',
  'g/cm3': 'g/cm3',
} as const;
